import React from 'react'
import Translation from '../General/Translation'
import TrailerPlayButton from './TrailerPlayButton'
import getBackgroundStyles from '../functions/getBackgroundStyles'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import { setTrailerMovie } from '../actions'

const mapDispatchToProps = (dispatch, ownProps) => ({
    setTrailerMovie: (url) => {
        dispatch(setTrailerMovie(url))
    }
})

const TrailerLarge = ({
    trailerURL, 
    fsk, 
    theme, 
    isMobile, 
    backgroundImage, 
    setTrailerMovie, 
    translation, 
    landscape=false
}) => {
    const styles = getBackgroundStyles(backgroundImage, true, isMobile)
    const trailerMovie = {
        trailerUrl: trailerURL,
        fsk: fsk
    }

    return (
        <div className="trailer-large trailer-wrapper-button trailer">
            {theme !== 'Arthouse' && <div className={'trailer-button-background-picture theme-radius-posters-full clip-mask'} style={styles} />}
            <div className={'trailer-button-background-picture theme-radius-posters-full'} style={styles} /> 
            
            {landscape ? (
                <p className="trailer-text-wrapper" onClick={() => setTrailerMovie(trailerMovie)}>
                    <TrailerPlayButton />
                    <span className="poster-attribute-text"><Translation id="playTrailer" trans={translation}>Trailer abspielen</Translation></span>
                </p>
            ) : (
                <p className="trailer-text-wrapper" onClick={() => setTrailerMovie(trailerMovie)}>
                    <span className="title-large"><Translation id="trailer" trans={translation}>Trailer</Translation></span>
                    <TrailerPlayButton />
                </p>
            )}
        </div>
    )
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(TrailerLarge)


